// extracted by mini-css-extract-plugin
export default {"error404":"Error404_error404__kiwaU","wrapper":"Error404_wrapper__R23pF"};